<div class="input">
  <label for="currency">Kreditsumme</label>
  <input
         #input
         id="currency"
         type="text"
         [formControl]="inputValue"
         (keyup)="onKeyup(input.value)"
         data-amount="inputAmount"
         maxlength="7"
         >
</div>
